const types = {
    INFORMES_GET_REFERENCIAS: 'INFORMES_GET_REFERENCIAS',
    INFORMES_GET_RESULTADOS: 'INFORMES_GET_RESULTADOS',
    INFORMES_SAVE_DATA: 'INFORMES_SAVE_DATA'
}

export default types;

export const getReferenciasData = () => {
    return { type: types.INFORMES_GET_REFERENCIAS };
}

export const getResultadosDataByReferencia = (referenciaId) => {
    return { type: types.INFORMES_GET_RESULTADOS, payload: { referenciaId } };
}

export const saveData = (values, onSuccess, onError) => {
    return { type: types.INFORMES_SAVE_DATA, payload: { values, onSuccess, onError } };
}